import { render, staticRenderFns } from "./display-field-text.vue?vue&type=template&id=186dbbd3&scoped=true&"
import script from "./display-field-text.ts?vue&type=script&lang=ts&"
export * from "./display-field-text.ts?vue&type=script&lang=ts&"
import style0 from "./display-field-text.scss?vue&type=style&index=0&id=186dbbd3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "186dbbd3",
  null
  
)

export default component.exports